/*
  Card image fit, worked out automatically for every product card image on every collection.
  Images marked data-card-fit (card-product.liquid) start as cover. Once each image loads, a tiny
  copy of it is read and one of three things happens:

  1. Photo with plain white strips or a white border saved around it (for example the Polo Ralph
     Lauren dress shots and the R.M.Williams Rod Polo shots). Shown zoomed just enough to push the
     strips outside the card. The zoom
     is measured per image, and the photo element itself is never resized or moved (see applyZoom),
     so the wishlist heart stays where it is.
  2. Product on a light or transparent backdrop (white, cream, light grey, PNG cut outs):
     - fills the card (cover) when the only thing cover would trim is backdrop (most model shots);
     - otherwise shown whole (contain), so toes, heels, bag ends and wallet edges are never cut.
     Any backdrop showing blends into the card colour (darken in component-card.css).
     A photo taller than the card whose left or right edge is not backdrop (a wall or room, like
     the English Laundry shirt shots) fills the card instead, because contain would leave card
     colour bands beside a visible photo edge.
  3. Everything else fills the card (cover): lifestyle shots, solid colour tiles, photos on a
     dark or coloured backdrop.

  If the tiny copy can't be read, the image stays on cover.
*/
(function () {
  if (window.cardImageFitBound) return;
  window.cardImageFitBound = true;

  var CARD_RATIO = 0.85;
  var SIZE = 64;

  function smallUrl(src) {
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', '96');
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function readPixels(probe) {
    var canvas = document.createElement('canvas');
    canvas.width = SIZE;
    canvas.height = SIZE;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.clearRect(0, 0, SIZE, SIZE);
    ctx.drawImage(probe, 0, 0, SIZE, SIZE);
    return ctx.getImageData(0, 0, SIZE, SIZE).data;
  }

  // The card colour the photo blends into. A backdrop only disappears into the card (darken)
  // when it is at least as light as the card, so that is the line between "backdrop" and
  // "photo". Read from the image area's background; falls back to a light grey.
  var cardColour = [235, 235, 230];

  function readCardColour(img) {
    // .product__media is the product page gallery box (product-thumbnail.liquid)
    var area = img.closest('.card__media') || img.closest('.card__inner') || img.closest('.product__media');
    if (!area) return;
    var match = window.getComputedStyle(area).backgroundColor.match(/\d+(\.\d+)?/g);
    if (match && match.length >= 3 && (match.length < 4 || parseFloat(match[3]) > 0)) {
      cardColour = [parseFloat(match[0]), parseFloat(match[1]), parseFloat(match[2])];
    }
  }

  // Backdrop: about as light as the card colour or lighter on every channel (white, cream, or the
  // same grey as the card, with a small allowance so warm cream backdrops still count), or
  // transparent. A grey backdrop darker than the card (some GANT shots) is
  // not backdrop, because it would show as a darker panel inside the card.
  function isLight(data, x, y) {
    var i = (y * SIZE + x) * 4;
    if (data[i + 3] < 128) return true;
    return data[i] >= cardColour[0] - 12 && data[i + 1] >= cardColour[1] - 12 && data[i + 2] >= cardColour[2] - 12;
  }

  // Blank: disappears completely into the card (darken), so it is at least as light as the card on
  // every channel, or transparent. Used to find white strips and borders saved around a photo.
  // A pale photo backdrop just under the card colour (the light grey behind the Rod Polo shots)
  // is not blank, so it marks where the photo starts.
  function isBlank(data, x, y) {
    var i = (y * SIZE + x) * 4;
    if (data[i + 3] < 128) return true;
    return data[i] >= cardColour[0] - 3 && data[i + 1] >= cardColour[1] - 3 && data[i + 2] >= cardColour[2] - 3;
  }

  function edgeShare(data, side) {
    var hits = 0;
    var total = 0;
    for (var n = 0; n < SIZE; n++) {
      for (var d = 0; d < 2; d++) {
        var x, y;
        if (side === 'top') { x = n; y = d; }
        if (side === 'bottom') { x = n; y = SIZE - 1 - d; }
        if (side === 'left') { x = d; y = n; }
        if (side === 'right') { x = SIZE - 1 - d; y = n; }
        if (isLight(data, x, y)) hits++;
        total++;
      }
    }
    return hits / total;
  }

  // Light or transparent backdrop around the outside of the image. A product often touches
  // two edges (a bag spanning the full width), so top and bottom, or left and right, is enough.
  function hasLightBackdrop(data) {
    var top = edgeShare(data, 'top');
    var bottom = edgeShare(data, 'bottom');
    var left = edgeShare(data, 'left');
    var right = edgeShare(data, 'right');
    if (top >= 0.8 && bottom >= 0.8) return true;
    if (left >= 0.8 && right >= 0.8) return true;
    // A product that runs off three sides of the photo (a bag cropped tight at the sides and
    // bottom, like Oran London) still has one clean backdrop edge.
    if (Math.max(top, bottom, left, right) >= 0.9) return true;
    return (top + bottom + left + right) / 4 >= 0.6;
  }

  // Share of blank pixels, and the average darkness, along one row or column. With middle set,
  // only the middle of the line is read, so a border running along the two neighbouring sides
  // doesn't count against it.
  function lineStats(data, side, d, middle) {
    var hits = 0;
    var shade = 0;
    var from = middle ? Math.floor(SIZE * 0.2) : 0;
    var to = middle ? SIZE - from : SIZE;
    for (var n = from; n < to; n++) {
      var x, y;
      if (side === 'top') { x = n; y = d; }
      if (side === 'bottom') { x = n; y = SIZE - 1 - d; }
      if (side === 'left') { x = d; y = n; }
      if (side === 'right') { x = SIZE - 1 - d; y = n; }
      var i = (y * SIZE + x) * 4;
      if (isBlank(data, x, y)) hits++;
      shade += Math.min(data[i], data[i + 1], data[i + 2]);
    }
    return { blank: hits / (to - from), shade: shade / (to - from) };
  }

  // A plain light strip saved along one side of a photo (for example the white strips down the
  // sides of the Polo Ralph Lauren dress shots, or the white border around the Rod Polo shots):
  // a few rows or columns that are all blank, then a row or column that is almost entirely a pale
  // photo backdrop (beige, stone, light grey).
  // Returns the strip depth on that side (0 to 1 of the image), or 0 if there is none. Half a row
  // is added because the tiny copy blends the row where the strip meets the photo, so the zoom
  // always clears the whole strip.
  // A product on a white backdrop does not match, because its backdrop never ends in a solid line.
  function stripDepth(data, side) {
    var limit = Math.floor(SIZE * 0.2);
    var d = 0;
    while (d < limit && lineStats(data, side, d).blank >= 0.95) d++;
    if (d === 0 || d >= limit) return 0;
    var next = lineStats(data, side, d, true);
    if (next.blank <= 0.08 && next.shade >= 140) return (d + 0.5) / SIZE;
    return 0;
  }

  // The deepest strip on any side, so one zoom clears them all.
  function frameDepth(data) {
    return Math.max(
      stripDepth(data, 'top'),
      stripDepth(data, 'bottom'),
      stripDepth(data, 'left'),
      stripDepth(data, 'right')
    );
  }

  // Zoom for photos with white strips saved along their sides. The photo element itself keeps
  // exactly its normal size and position, because the wishlist heart is placed from it. Instead,
  // the same photo is drawn as the background of its .media box, enlarged and centred, and the
  // photo element is made see-through on top of it. The box clips the strips off.
  var zoomBoxes = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { drawZoom(entry.target); });
  }) : null;

  function drawZoom(box) {
    var img = box.querySelector('img[data-card-zoom]');
    if (!img) return;
    var zoom = parseFloat(img.getAttribute('data-card-zoom')) || 1;
    var w = box.clientWidth;
    var h = box.clientHeight;
    if (!w || !h || !img.naturalWidth) return;
    var ratio = img.naturalWidth / img.naturalHeight;
    var coverW = w / h > ratio ? w : h * ratio;
    var coverH = w / h > ratio ? w / ratio : h;
    box.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    box.style.backgroundRepeat = 'no-repeat';
    box.style.backgroundPosition = 'center center';
    box.style.backgroundSize = Math.ceil(coverW * zoom) + 'px ' + Math.ceil(coverH * zoom) + 'px';
  }

  function applyZoom(img, zoom) {
    var box = img.closest('.media');
    if (!box || img !== box.querySelector('img')) return;
    img.setAttribute('data-card-zoom', zoom.toFixed(3));
    img.style.opacity = '0';
    drawZoom(box);
    if (zoomBoxes) zoomBoxes.observe(box);
  }

  function setMode(img, mode, zoom) {
    img.classList.toggle('card__img--contain', mode === 'contain');
    img.classList.toggle('card__img--cover', mode === 'cover');
    img.setAttribute('data-card-fit', mode);
    if (zoom && zoom > 1) applyZoom(img, zoom);
  }

  // White or very light products on a light grey backdrop (the Ben Sherman white socks).
  // The darken blend that turns light backdrops into the card colour also turns the white
  // product into the card colour, so it disappears. When the middle of the photo has a fair
  // amount of white that is clearly lighter than the photo's own backdrop, the photo is drawn
  // normally (no blend) on its own backdrop colour instead, so the product keeps its edges.
  // Products on a pure white backdrop are not affected: nothing in the photo is lighter than it.
  function edgeAverage(data) {
    var r = 0, g = 0, b = 0, n = 0, total = 0;
    for (var k = 0; k < SIZE; k++) {
      [[k, 0], [k, SIZE - 1], [0, k], [SIZE - 1, k]].forEach(function (p) {
        var i = (p[1] * SIZE + p[0]) * 4;
        total++;
        // Only the backdrop part of the edge counts (light pixels), not product touching it.
        if (data[i + 3] < 128 || !isLight(data, p[0], p[1])) return;
        r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
      });
    }
    if (!n || n / total < 0.3) return null;
    return [Math.round(r / n), Math.round(g / n), Math.round(b / n)];
  }

  // Transparent cut out photos (PNG with no backdrop). The card colour already shows through
  // the transparent parts, so no blend is needed, and the blend would turn a white product the
  // card colour. Light products (mostly lighter than the card, like white socks) sit on the
  // brand dark green (#404C38, the footer green) instead so they stand out; darker products
  // keep the normal card colour.
  function transparentShare(data) {
    var clear = 0, total = 0;
    for (var k = 0; k < SIZE; k++) {
      [[k, 0], [k, SIZE - 1], [0, k], [SIZE - 1, k]].forEach(function (p) {
        total++;
        if (data[(p[1] * SIZE + p[0]) * 4 + 3] < 128) clear++;
      });
    }
    return clear / total;
  }

  function handleCutout(img, data) {
    if (transparentShare(data) < 0.5) return false;
    var light = 0, solid = 0;
    for (var y = 0; y < SIZE; y++) {
      for (var x = 0; x < SIZE; x++) {
        var i = (y * SIZE + x) * 4;
        if (data[i + 3] < 128) continue;
        solid++;
        // Light: white, cream or off white (the Ben Sherman socks are about 247,244,231, which is
        // only just lighter than the card, so "lighter than the card" alone misses them).
        var lo = Math.min(data[i], data[i + 1], data[i + 2]);
        var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
        if (lo >= 190 && avg >= 215) light++;
      }
    }
    img.style.mixBlendMode = 'normal';
    if (solid && light / solid >= 0.4) {
      img.setAttribute('data-card-light-product', '');
      var box = img.closest('.media');
      if (box && img === box.querySelector('img')) {
        var area = img.closest('.card__media');
        // Brand dark green, the same as the footer (#404C38). Set through an attribute so the
        // stylesheet can switch it back to the card colour while the hover photo is showing
        // (see data-card-bg in component-card.css).
        box.setAttribute('data-card-bg', 'green');
        if (area) area.setAttribute('data-card-bg', 'green');
      }
    }
    return true;
  }

  function keepLightProduct(img, data) {
    if (img.hasAttribute('data-card-zoom')) return;
    if (handleCutout(img, data)) return;
    var edge = edgeAverage(data);
    if (!edge) return;
    var edgeMax = Math.max(edge[0], edge[1], edge[2]);
    if (edgeMax >= 250) return;
    var from = Math.floor(SIZE * 0.2), to = SIZE - from, hits = 0, total = 0;
    for (var y = from; y < to; y++) {
      for (var x = from; x < to; x++) {
        var i = (y * SIZE + x) * 4;
        total++;
        if (data[i + 3] < 128) continue;
        var lo = Math.min(data[i], data[i + 1], data[i + 2]);
        if (lo >= edgeMax + 8 && lo >= Math.max(cardColour[0], cardColour[1], cardColour[2]) + 4) hits++;
      }
    }
    if (hits / total < 0.06) return;
    var box = img.closest('.media');
    img.style.mixBlendMode = 'normal';
    img.setAttribute('data-card-light-product', '');
    if (box && img === box.querySelector('img')) {
      var colour = 'rgb(' + edge.join(',') + ')';
      box.style.backgroundColor = colour;
      var area = img.closest('.card__media');
      if (area) area.style.backgroundColor = colour;
    }
  }

  function decide(img, probe) {
    readCardColour(img);
    var data;
    try {
      data = readPixels(probe);
    } catch (e) {
      setMode(img, 'cover');
      return;
    }
    chooseMode(img, data);
    keepLightProduct(img, data);
  }

  function chooseMode(img, data) {
    var ratio = img.naturalWidth / img.naturalHeight;

    var frame = frameDepth(data);
    if (frame > 0) {
      setMode(img, 'cover', Math.min(1 / (1 - 2 * frame) + 0.02, 1.6));
      return;
    }

    if (!hasLightBackdrop(data)) {
      setMode(img, 'cover');
      return;
    }

    // Light backdrop, no frame. Fill the card (cover) when the only thing cover would trim is
    // backdrop; otherwise show the whole product (contain) so nothing is cut off.
    // Photos within about 10% of the card's shape (most model shots) fill it either way, since
    // cover only trims a sliver.
    if (Math.abs(ratio - CARD_RATIO) <= 0.1) {
      setMode(img, 'cover');
      return;
    }

    // Taller than the card: contain puts card colour bands down the left and right. If either of
    // those photo edges is a wall or room rather than backdrop, the band shows a hard line against
    // it, so fill the card instead.
    if (ratio < CARD_RATIO && Math.min(edgeShare(data, 'left'), edgeShare(data, 'right')) < 0.5) {
      setMode(img, 'cover');
      return;
    }
    setMode(img, coverTrimsOnlyBackdrop(data, ratio) ? 'cover' : 'contain');
  }

  // Where the product sits: the box around every pixel that isn't light or transparent.
  function productBox(data) {
    var minX = SIZE, minY = SIZE, maxX = -1, maxY = -1;
    for (var y = 0; y < SIZE; y++) {
      for (var x = 0; x < SIZE; x++) {
        if (!isLight(data, x, y)) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    return { left: minX / SIZE, right: (maxX + 1) / SIZE, top: minY / SIZE, bottom: (maxY + 1) / SIZE };
  }

  // Cover trims the sides of an image wider than the card, and the top and bottom of an image
  // taller than the card. True when the product sits inside what cover keeps.
  function coverTrimsOnlyBackdrop(data, ratio) {
    var box = productBox(data);
    if (!box) return true;
    var margin = 1 / SIZE;
    if (ratio > CARD_RATIO) {
      var side = (1 - CARD_RATIO / ratio) / 2;
      return box.left >= side + margin && box.right <= 1 - side - margin;
    }
    var edge = (1 - ratio / CARD_RATIO) / 2;
    return box.top >= edge + margin && box.bottom <= 1 - edge - margin;
  }

  function fit(img) {
    if (img.getAttribute('data-card-fit')) return;
    if (!img.complete || !img.naturalWidth) return;
    img.setAttribute('data-card-fit', 'checking');

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () { decide(img, probe); };
    probe.onerror = function () { setMode(img, 'cover'); };
    probe.src = smallUrl(img.currentSrc || img.src);
  }

  function fitAll() {
    document.querySelectorAll('img[data-card-fit=""]').forEach(fit);
  }

  document.addEventListener('load', function (e) {
    var img = e.target;
    if (img && img.tagName === 'IMG' && img.getAttribute('data-card-fit') === '') fit(img);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }

  new MutationObserver(fitAll).observe(document.documentElement, { childList: true, subtree: true });
})();